/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AddressBook } from './addressBook';
import { AddressBookContactDto } from './addressBookContactDto';

export interface CreateAddressBookDto { 
    addressBook?: AddressBook;
    addressBookContact?: AddressBookContactDto;
    addressBookNames?: string;
    contacts?: string;
}